import buried from './buried'
import clickBuried from './click-buried'
import pageBuried from './page-buried'
const directivesList = { buried, clickBuried, pageBuried }
export default function installDirectives(app) {
  Object.keys(directivesList).forEach((key) => {
    app.directive(key, directivesList[key])
  })
}
